import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class RecipientModel {
    static fromDTO(dto) {
        return new RecipientModel(dto.firstName, dto.lastName, dto.email, dto.notificationId, dto.isSignatureRequired, dto.hasSigned, "https://".concat(window.location.host, "/notification/").concat(dto.notificationId));
    }
    fullName() {
        return "".concat(this.firstName, " ").concat(this.lastName);
    }
    constructor(firstName, lastName, email, notificationId, isSignatureRequired, hasSigned, notificationURL){
        _define_property(this, "firstName", void 0);
        _define_property(this, "lastName", void 0);
        _define_property(this, "email", void 0);
        _define_property(this, "notificationId", void 0);
        _define_property(this, "isSignatureRequired", void 0);
        _define_property(this, "hasSigned", void 0);
        _define_property(this, "notificationURL", void 0);
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.notificationId = notificationId;
        this.isSignatureRequired = isSignatureRequired;
        this.hasSigned = hasSigned;
        this.notificationURL = notificationURL;
    }
}
